// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.equipment_status_enum */
var EquipmentStatusEnum;
(function (EquipmentStatusEnum) {
    EquipmentStatusEnum["ACTIVE"] = "ACTIVE";
    EquipmentStatusEnum["INACTIVE"] = "INACTIVE";
    EquipmentStatusEnum["DECOMMISSIONED"] = "DECOMMISSIONED";
})(EquipmentStatusEnum || (EquipmentStatusEnum = {}));
;
export default EquipmentStatusEnum;
/** Zod schema for equipment_status_enum */
export const equipmentStatusEnum = z.nativeEnum(EquipmentStatusEnum);
//# sourceMappingURL=EquipmentStatusEnum.js.map